/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: Material Design
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const PanoramaPhotosphere = (props: Props): JSX.Element => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M21.4 11.3v3l-3.3 1.1c-1 .3-3.9.7-6.1.7-3.7 0-7-.7-9.2-1.8h-.2V9.7a21 21 0 0 1 18.8 0v1.5zM12 20.2a8.1 8.1 0 0 1-6.4-3.1c4.2 1.2 8.6 1.2 12.8 0a8.1 8.1 0 0 1-6.4 3.1m0-16.4a8 8 0 0 1 6.4 3.1A23 23 0 0 0 5.6 7 8.2 8.2 0 0 1 12 3.8m10.5 4.7L21 8A10 10 0 0 0 2.8 8l-1.4.6a1 1 0 0 0-.5.8v5.4c0 .3.2.6.5.8L3 16a10 10 0 0 0 18.2 0l1.4-.6c.3-.2.5-.5.5-.8V9.3a1 1 0 0 0-.5-.8z" />
  </Icon>
);
